import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AdminNavBar } from "../components/AdminNavBar";
import { ContainerDetails } from "../components/containers";
import styled from "@emotion/styled";

const Container = styled.div`
  padding: 24px;
`;

const ContainerDetailsPage: React.FC = () => {
  const { containerId } = useParams<{ containerId: string }>();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/admin/containers");
  };

  if (!containerId || isNaN(parseInt(containerId))) {
    navigate("/admin/containers");
    return null;
  }

  return (
    <>
      <AdminNavBar />
      <Container>
        <ContainerDetails
          containerId={parseInt(containerId)}
          onBack={handleBack}
        />
      </Container>
    </>
  );
};

export default ContainerDetailsPage;
